<template>
  <div class="search-card">
    <base-spinner class="dialog-spinner" v-if="showSpinner"></base-spinner>
    <div ref="autocompleteHost" class="autocomplete-host"></div>
    <base-button class="nearby-button" @click.prevent="$emit('nearbySearch')"
      >Umkreis</base-button
    >
  </div>
</template>

<script>
import createPlaceMixin from "../../mixins/createPlace.js";
export default {
  mounted() {
    this.prepareAutoComplete();
  },
  watch: {
    update() {
      this.prepareAutoComplete();
    },
  },
  beforeUnmount() {
    this.teardownAutoComplete();
  },
  mixins: [createPlaceMixin],
  props: ["update"],
  emits: ["nearbySearch", "setError"],
  data() {
    return {
      autocomplete: null,
      showSpinner: false,
      onPlaceSelect: null,
    };
  },
  methods: {
    async prepareAutoComplete() {
      if (!window.google || this.autocomplete || !this.$refs.autocompleteHost) {
        return;
      }

      const { PlaceAutocompleteElement } =
        await window.google.maps.importLibrary("places");
      if (this.autocomplete || !this.$refs.autocompleteHost) {
        return;
      }

      const placeAutocomplete = new PlaceAutocompleteElement();
      placeAutocomplete.placeholder = "Name oder Adresse weltweit ";
      this.$refs.autocompleteHost.appendChild(placeAutocomplete);

      this.onPlaceSelect = async (event) => {
        try {
          const place = event.placePrediction.toPlace();
          await place.fetchFields({
            fields: [
              "displayName",
              "formattedAddress",
              "location",
              "types",
              "id",
              "photos",
              "internationalPhoneNumber",
              "websiteURI",
            ],
          });
          if (!place.location) {
            this.$emit(
              "setError",
              "Bitte wähle einen der vorgeschlagenen Places aus"
            );
            return;
          }
          this.showSpinner = true;
          await this.createPlaceFromGooglePlace(place);
        } catch (error) {
          console.error("Failed to load selected place", error);
          this.$emit("setError", "Fehler beim Anlegen des Nice Place");
          this.showSpinner = false;
        }
      };

      placeAutocomplete.addEventListener("gmp-select", this.onPlaceSelect);
      this.autocomplete = placeAutocomplete;
    },
    teardownAutoComplete() {
      if (this.autocomplete && this.onPlaceSelect) {
        this.autocomplete.removeEventListener("gmp-select", this.onPlaceSelect);
      }
      if (this.autocomplete?.parentNode) {
        this.autocomplete.parentNode.removeChild(this.autocomplete);
      }
      this.autocomplete = null;
      this.onPlaceSelect = null;
    },
    async createPlaceFromGooglePlace(googlePlace) {
      const newPlace = this.createPlace(googlePlace);
      if (newPlace == null) {
        this.$emit("setError", "Fehler beim Anlegen des Nice Place");
        this.showSpinner = false;
        return;
      }

      let places = this.$store.getters.places;
      let storedPlace = places.find((p) => p.id === newPlace.id);
      if (storedPlace == null) {
        // if not already stored
        try {
          await this.$store.dispatch("addPlace", newPlace);
        } catch (error) {
          this.$emit("setError", "Fehler beim Anlegen des Nice Place");
          this.showSpinner = false;
          return;
        }
      }
      this.showSpinner = false;

      const latLng = new window.google.maps.LatLng(newPlace.lat, newPlace.lng);
      this.$store.dispatch("setCenter", latLng);
    },
  },
};
</script>

<style scoped>
.search-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: solid lightgrey 1px;
  padding: 0.5rem;
  background-color: rgb(242, 241, 240);
}

.autocomplete-host {
  flex: 1;
  min-width: 0;
}

:deep(gmp-place-autocomplete) {
  width: 100%;
  max-width: 60vw;
  height: 2rem;
  font-size: 0.875rem;
  color-scheme: light;
}

.nearby-button {
  flex-shrink: 0;
}

@media (min-width: 768px) {
  :deep(gmp-place-autocomplete) {
    max-width: 50vw;
  }

  .search-card {
    padding: 0.7rem;
  }
}
</style>
